// extracted by mini-css-extract-plugin
export var container = "_1a-0";
export var disabled = "_1a-4";
export var fullWidth = "_1a-3";
export var lined = "_1a-1";
export var selected = "_1a-5";
export var tab = "_1a-2";